interface TeamWithCompetition {
  competition?: { id: string } | null
}

/**
 * Whether a player whose current team is `team` still plays in the reference
 * competition (see ReferenceCompetitionContext).
 *
 * - No team: the player is out.
 * - No reference competition: having a team is enough.
 * - `team.competition` not fetched by the query (undefined): we cannot tell, so
 *   the player is not flagged rather than risk a false "No está en la liga".
 * - Otherwise the team must play in the reference competition this season
 *   (`null` means it is not registered in any active competition).
 */
export const isPlayerInCompetition = (
  team: TeamWithCompetition | null | undefined,
  referenceCompetitionId: string | undefined
): boolean => {
  if (!team) return false
  if (!referenceCompetitionId) return true
  if (team.competition === undefined) return true

  return team.competition?.id === referenceCompetitionId
}
